var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23508 4.6425L5.45258 1.86C5.40008 1.8075 5.33258 1.7625 5.25758 1.7325C5.25008 1.7325 5.24258 1.7325 5.23508 1.725C5.17508 1.7025 5.11508 1.6875 5.04758 1.6875C4.89758 1.6875 4.75508 1.7475 4.65008 1.8525L1.85258 4.6425C1.63508 4.86 1.63508 5.22 1.85258 5.4375C2.07008 5.655 2.43008 5.655 2.64758 5.4375L4.48508 3.6V15.75C4.48508 16.0575 4.74008 16.3125 5.04758 16.3125C5.35508 16.3125 5.61008 16.0575 5.61008 15.75V3.6075L7.44008 5.4375C7.55258 5.55 7.69508 5.6025 7.83758 5.6025C7.98008 5.6025 8.12258 5.55 8.23508 5.4375C8.45258 5.22 8.45258 4.8675 8.23508 4.6425Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1474 12.5625C15.9299 12.345 15.5699 12.345 15.3524 12.5625L13.5149 14.4V2.25C13.5149 1.9425 13.2599 1.6875 12.9524 1.6875C12.6449 1.6875 12.3899 1.9425 12.3899 2.25V14.3925L10.5599 12.5625C10.3424 12.345 9.98243 12.345 9.76493 12.5625C9.54743 12.78 9.54743 13.14 9.76493 13.3575L12.5474 16.14C12.5999 16.1925 12.6674 16.2375 12.7424 16.2675C12.7499 16.2675 12.7574 16.2675 12.7649 16.275C12.8249 16.2975 12.8924 16.3125 12.9599 16.3125C13.1099 16.3125 13.2524 16.2525 13.3574 16.1475L16.1474 13.3575C16.3649 13.1325 16.3649 12.78 16.1474 12.5625Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3Filled);
export default __webpack_public_path__ + "static/media/arrow-3_filled.d18c35de3fb2d89a220bdc7fa4c15213.svg";
export { ForwardRef as ReactComponent };